import { render } from "./userForm.vue?vue&type=template&id=a85dd032&scoped=true"
import script from "./userForm.vue?vue&type=script&lang=js"
export * from "./userForm.vue?vue&type=script&lang=js"

import "./userForm.vue?vue&type=style&index=0&id=a85dd032&lang=less&scoped=true"
import "./userForm.vue?vue&type=style&index=1&id=a85dd032&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a85dd032"]])

export default __exports__